import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostObjektNutzungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostObjektNutzungCommandService],
  exports: []
})
export class PostObjektNutzungCommandServiceModule { }
